import { render, staticRenderFns } from "./ManufacturingLabor.vue?vue&type=template&id=51f8dd65&scoped=true&"
import script from "./ManufacturingLabor.vue?vue&type=script&lang=js&"
export * from "./ManufacturingLabor.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingLabor.vue?vue&type=style&index=0&id=51f8dd65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8dd65",
  null
  
)

export default component.exports